import React from 'react';

export default function EngineSources({ id, intro, sources }) {
  return (
    <section className="expression-engine__sources" aria-labelledby={id}>
      <h2 id={id}>Sources</h2>
      <p className="expression-engine__sub">{intro}</p>
      <div className="expression-engine__source-grid">
        {sources.map((source) => (
          <article key={source.title} className="expression-engine__source">
            <p className="expression-engine__source-role">{source.role}</p>
            <h3>{source.title}</h3>
            <p>{source.body}</p>
            <cite>{source.cite}</cite>
          </article>
        ))}
      </div>
    </section>
  );
}
